export const backendPoint = process.env.GATSBY_GRAPHQL_ENDPOINT
export const edshopBuilderUrl = process.env.GATSBY_EDSHOP_BUILDER_URL
export const siteUrl = process.env.GATSBY_SITE_URL
